import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function ProtectedRoute() {
  const { user, loading, profile } = useAuth();
  const location = useLocation();

  if (loading) return <div className="full-screen-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  // New feature: everyone builds a profile once after login (new and existing students).
  if (profile && !profile.completed && location.pathname !== "/welcome") {
    return <Navigate to="/welcome" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
